import { Stack, Typography, Box } from "@mui/material";
import { LoaderButton } from "../../mui";
import { CountdownTimer } from "../components";
import { DIGITAL_TWIN_ACTION } from "../common";

const TIMER2_SEC = 25;

const DoorActionButtons = ({
  status,
  action,
  selectedDoor,
  handleOpenDoorCommand,
  handleTimerCompleted2,
  handleMarkedDoorClose,
}) => {
  const isInBattery = action === DIGITAL_TWIN_ACTION.IN_BATTERY;
  const timer2Done = !isInBattery || status.isTimerCompleted2;

  const isMarkDoorCloseEnabled =
    (status.isDoorOpen && status.isInitDoorOpen) ||
    (status.isDoneDoorClose && status.isInitDoorOpen) ||
    status.isCompleted;

  const showTimer =
    isInBattery &&
    status.isInitDoorOpen &&
    status.isDoorOpen &&
    !status.isTimerCompleted2;

  const isOpen = !status.isDoneDoorClose && status.isDoorOpen;

  const renderDoorStatus = () => (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{
        px: 1.5,
        py: 0.75,
        flexShrink: 0,
        borderRadius: 999,
        border: "1px solid",
        borderColor: isOpen ? "#B7E4C7" : "#F5C2C2",
        bgcolor: isOpen ? "#EAF7EF" : "#FDECEC",
        color: isOpen ? "#1B7F43" : "#B42318",
      }}
    >
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          bgcolor: "currentColor",
          boxShadow: isOpen ? "0 0 0 4px rgba(27,127,67,.18)" : "none",
        }}
      />
      <Typography sx={{ fontSize: 14, fontWeight: 600, lineHeight: 1 }}>
        {isOpen ? `Door ${selectedDoor} open` : `Door ${selectedDoor} closed`}
      </Typography>
    </Stack>
  );

  const buttonSx = {
    flex: { xs: 1, sm: "none" },
    minWidth: { xs: 0, sm: 200 },
    maxWidth: 230,
    height: 44,
    px: 3,
    borderRadius: 2,
    textTransform: "none",
    fontSize: 15,
    fontWeight: 600,
    boxShadow: "none",
    "&:hover": { boxShadow: "none" },
  };

  const renderButton = () => {
    if (isMarkDoorCloseEnabled) {
      return (
        <LoaderButton
          variant="contained"
          onClick={handleMarkedDoorClose}
          isLoading={false}
          sx={buttonSx}
          disabled={
            status.isCompleted ||
            !timer2Done ||
            (status.isDoneDoorClose && selectedDoor !== null)
          }
        >
          Mark door closed
        </LoaderButton>
      );
    }
    return (
      <LoaderButton
        variant="contained"
        onClick={handleOpenDoorCommand}
        isLoading={status.isInitDoorOpen && !status.isDoorOpen}
        sx={buttonSx}
        disabled={status.isDoorOpen || status.isInitDoorOpen}
      >
        Open door
      </LoaderButton>
    );
  };

  if (selectedDoor === null) return null;

  return (
    <Stack spacing={1.5} sx={{ width: "100%" }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={1.5}
      >
        {renderDoorStatus()}
        {renderButton()}
      </Stack>
      {showTimer && (
        <CountdownTimer
          key="timer2"
          text="Please close the door within"
          onComplete={handleTimerCompleted2}
          seconds={TIMER2_SEC}
          sx={{ width: "100%", justifyContent: "space-between" }}
        />
      )}
    </Stack>
  );
};

export default DoorActionButtons;